import { SettingsData } from './hooks/use-settings-data.hook';

export const enum SettingsRowKey {
  name = 'name',
  dob = 'dob',
  sex = 'sex',
  address = 'address',
  phone = 'phone',
  accountEmail = 'accountEmail',
  password = 'password',
}

export type SettingsSectionBaseProps = {
  userId: string;
  data: SettingsData;
  isLoading: boolean;
};
